import type { UserGroup } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { findRecord, query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

// User groups tagged as coach pools carry this category.
export const COACH_POOL_CATEGORY = 'coach-pool';

export function findUserGroup(id: string) {
  return findRecord<UserGroup>(DataTypeSystem.UserGroup, id, jsonApiOptions);
}

export function queryUserGroups(clientId: string) {
  return query<UserGroup>(
    DataTypeSystem.UserGroup,
    {
      'filter[client.id]': clientId,
      'filter[scope]': 'client',
    },
    jsonApiOptions
  );
}
